import { render, staticRenderFns } from "./VorstossDetailDialog.vue?vue&type=template&id=cbdb45e6&scoped=true"
import script from "./VorstossDetailDialog.vue?vue&type=script&lang=js"
export * from "./VorstossDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./VorstossDetailDialog.vue?vue&type=style&index=0&id=cbdb45e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbdb45e6",
  null
  
)

export default component.exports